var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 19.207a2 2 0 002 2h14a2 2 0 002-2v-5h-2v5H5v-5H3v5zm12.223-7.991l-2.163 2.163V2.793h-2v10.586l-2.163-2.163-1.414 1.414 4.577 4.577 4.577-4.577-1.414-1.414z",
    fill: "#121314"
  })));
}
export default SvgLarge;